<template>
  <div class="dialogDetail">
    <div class="con">
      <div class="con-1">
        <p class="p"><i>视频标题：</i><span>{{detailInfo.title}}</span></p>
        <p class="p"><i>视频类型：</i><span>{{formattervedioType('','',detailInfo.type)}}</span></p>
      </div>
      <div class="con-1">
        <p class="p"><i>课程目录：</i><span>{{detailInfo.directoryName}}</span></p>
        <p class="p"><i>关键字：</i><span>{{detailInfo.keys}}</span></p>
      </div>
      <div class="con-1">
        <p class="p"><i>适合专业：</i><span>{{detailInfo.professionName}}</span></p>
      </div>
    </div>
    <VideoPlayer ref="VideoPlayer" :videoUrl="videoUrl"/>
  </div>
</template>

<script>
import formatter from '@/mixin/formatter.js';
import VideoPlayer from '@/components/VideoPlayer';
import { vedioServer } from '@/api/api'
export default {
  mixins: [formatter],
//   extends: VideoPlayer,
  components: {VideoPlayer},
  data () {
    return {
      detailInfo: {},
      videoUrl: null
    }
  },
  methods: {
    getDetail (id) {
      this.detailInfo = {}
      vedioServer.vedioDetail({
        id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.detailInfo = data
          this.getfileurl(data.filePath)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    getfileurl (fileKeys) {
      this.$getUrl({
      fileKeys
      }).then(obj => {
        if (obj) {
          this.videoUrl = obj[fileKeys]
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.con {
  background: #f5f6fa;
  margin-bottom: 20px;
  padding: 20px;
  text-align: left;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
  .h1{
    color: #333;
    font-size: 15px;
    margin-bottom: 10px;
  }
  p {
    img {
      width: 30px;
      height: 30px;
    }
  }
  .con-1, .con-2{
    display: flex;
    justify-content: space-between;
    p {
      display: inline-block;
      width: 50%;
    }
  }
  .p{
    display: flex;
    justify-content: start;
    i{
      display: inline-block;
    }
    span{
      display: inline-block;
    }
  }
  .long{
    position: relative;
    padding-left: 78px;
    min-height: 22px;
    i{
      position: absolute;
      left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/resource/details/vediodetail.vue